
import parserScripts from '~/helpers/parser-scripts';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'HtmlScriptBlock',
  mounted: function () {
    this.setScripts();
  },

  methods: {
    setScripts: function () {
      let scripts = this.values?.scripts || '';
      if (!scripts) {
        return;
      }

      scripts = parserScripts(scripts);

      const functionAddScript = (list, index) => {
        const script = list[index];
        const element = document.createElement('script');
        Object.keys(script).map((key) => {
          element[key] = script[key];
        });
        const done = false;
        element.onload = script.onreadystatechange = function () {
          if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
            if (list[index + 1]) {
              functionAddScript(list, index + 1);
            }
          }
        };
        document.body.appendChild(element);
      };

      const bodyHtml = document.body.innerHTML;
      functionAddScript(scripts, 0);
    },
  },
});
